export default __webpack_public_path__ + "static/media/pressure.37f0a961.svg";